module.exports = __webpack_public_path__ + "static/media/info.fd2f5513.svg";